import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {addSubField} from "../../../../../store/actions/subFields";
import{changeGroupField} from "../../../../../store/actions/groupFields";
import {connect} from "react-redux";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import ClassicCustomFieldsNotice from "../../../ClassicCustomFieldsNotice";
import {isCustomFieldValid} from "../../../ClassicFunctions";

const CustomFieldsFilter = (props) => {

	const {addSubField, group, premium} = props;

	const newCustomField = {
		name:   'custom-field',
		label:  'Custom field',
		fields: [
			getFieldFactory().getSourceField(), getFieldFactory().getValueInputType(), {
				id:        'customFieldName',
				inputType: 'input',
				value:     '',
				label:     'Custom field name',
				dynamic:   false,
			}, getFieldFactory().getParametersField(), getFieldFactory().getDynamicField()
		],
	};

	return (
		<React.Fragment>

			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (<React.Fragment>
					<h3>Custom Fields ({endpoint.createPosts[currentItem].customFields.length})</h3>

					<ParametersNotice parameters={endpoint.parameters}/>

					<button onClick={() => (premium || isCustomFieldValid(endpoint.createPosts[currentItem].customFields.length)) && addSubField(endpointId, [ newCustomField ], currentItem, group, action)} className="button-secondary">
						Add custom field
					</button>

          <ClassicCustomFieldsNotice />

					<FieldGroups group={group}/>

				</React.Fragment>)}
			</FieldGroupContext.Consumer>
		</React.Fragment>
	);
};

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
	changeGroupField: ( endpointId, group, index, field, value ) => dispatch( changeGroupField( endpointId, group, index, field, value ) )
});

export default connect( mapStateToProps, mapDispatchToProps )(CustomFieldsFilter);
